import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/purchase-orders`;

export const purchaseOrdersAPI = {
  async getAll() {
    return apiClient(`${BASE}/`);
  },

  async getAllItems() {
    return apiClient(`${BASE}/items`);
  },

  async getCatalog(itemType = '') {
    const query = itemType ? `?item_type=${encodeURIComponent(itemType)}` : '';
    return apiClient(`${BASE}/catalog${query}`);
  },

  async createCatalogItem(data) {
    return apiClient(`${BASE}/catalog`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async updateCatalogItem(id, data) {
    return apiClient(`${BASE}/catalog/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async getById(id) {
    return apiClient(`${BASE}/${id}`);
  },

  async create(data) {
    return apiClient(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id) {
    return apiClient(`${BASE}/${id}`, {
      method: 'DELETE',
    });
  },

  async bulkDelete(ids) {
    return apiClient(`${BASE}/bulk-delete`, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
  },

  async bulkAssign(data) {
    return apiClient(`${BASE}/bulk-assign`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },

  async parseBulkFile(file) {
    const body = new FormData();
    body.append('file', file);
    return apiClient(`${BASE}/bulk-import/parse`, {
      method: 'POST',
      body,
      timeoutMs: 180000,
    });
  },

  async bulkImport(orders) {
    return apiClient(`${BASE}/bulk-import`, {
      method: 'POST',
      body: JSON.stringify({ orders }),
      timeoutMs: 180000,
    });
  },

  async parseBulkItemsFile(file) {
    const body = new FormData();
    body.append('file', file);
    return apiClient(`${BASE}/bulk-import-items/parse`, {
      method: 'POST',
      body,
      timeoutMs: 180000,
    });
  },

  async bulkImportItems(items) {
    return apiClient(`${BASE}/bulk-import-items`, {
      method: 'POST',
      body: JSON.stringify({ items }),
      timeoutMs: 180000,
    });
  },

  async duplicate(id) {
    return apiClient(`${BASE}/${id}/duplicate`, {
      method: 'POST',
    });
  },

  async newVersion(id) {
    return apiClient(`${BASE}/${id}/new-version`, {
      method: 'POST',
    });
  },

  async fragment(id) {
    return apiClient(`${BASE}/${id}/fragment`, {
      method: 'POST',
    });
  },

  async requestApproval(id) {
    return apiClient(`${BASE}/${id}/request-approval`, {
      method: 'POST',
    });
  },

  async approve(id) {
    return apiClient(`${BASE}/${id}/approve`, {
      method: 'POST',
    });
  },

  async reject(id) {
    return apiClient(`${BASE}/${id}/reject`, {
      method: 'POST',
    });
  },

  async markPaid(id, { late = false } = {}) {
    return apiClient(`${BASE}/${id}/mark-paid`, {
      method: 'POST',
      body: JSON.stringify({ late: Boolean(late) }),
    });
  },

  async updateInvoicing(id, data) {
    return apiClient(`${BASE}/${id}/invoicing`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },
};

export default purchaseOrdersAPI;
